/* eslint-disable no-duplicate-case */
import React, { useState, useEffect } from "react";
import "../../css/christmas.css";
import { TextContainer, Modal, Button } from "@shopify/polaris";

import config from "../../config/config";
import callApi from "../../utils/apiCaller";

import { Row } from "reactstrap";
import { useSelector } from "react-redux";
import StarRatings from "react-star-ratings";
import Feedback from "./Feedback";

import gift1 from "../../assets/gift/1.png";
const Poll = () => {
  const dataSettings = useSelector((state) => state.dataSettings);
  const [modalActive, setModalActive] = useState(false);
  const [step, setstep] = useState(1);

  useEffect(() => {
    if (config.checkLocalStorage) {
      if (
        // localStorage.getItem(config.shop + "-synctrack-plan") &&
        localStorage.getItem(config.shop + "-synctrack-show-feedback-modal") !=
          1 &&
        localStorage.getItem(config.shop + "-synctrack-plan") !=
          dataSettings.plan &&
        dataSettings.plan !== "free" &&
        dataSettings.plan !== "unlimited"
      ) {
        callApi("get", {
          action: "checkSubmitFeedback",
        }).then(async (res) => {
          if (res.data.state === 1) {
            setModalActive(false);
          } else {
            setModalActive(true);
          }
        });
      }
    }
  }, []);

  const closeModal = async () => {
    setModalActive(false);
    if (config.checkLocalStorage) {
      localStorage.setItem(config.shop + "-synctrack-show-feedback-modal", 1);
    }
  };

  const grabGiftFeedback = () => {
    setstep(2);
    if (config.checkLocalStorage) {
      localStorage.setItem(config.shop + "-synctrack-show-feedback-modal", 1);
    }
    callApi("get", {
      action: "grabGiftFeedback",
    });
  };

  return (
    <Row>
      <Modal open={modalActive} onClose={closeModal}>
        <Modal.Section>
          <TextContainer>
            {step == 1 ? (
              <div
                className="text-center"
                style={{ lineHeight: "32px", fontSize: "16px" }}
              >
                <div className="omg-corgi-content-wrap">
                  <div className="omg-corgi-content">
                    <h4 className="text-left">
                      <b>Thank you, {dataSettings.shop_owner}</b>
                    </h4>
                    <img className="w-50" src={gift1} alt="omg-review" />
                    <h4>
                      We’d love to give you an <b>extra</b> of{" "}
                      <b>100 trackings/month</b> as a gift for all of your time
                      and choosing Synctrack.{" "}
                    </h4>
                    <h6 className=" text-center">
                      Click the button if you like our gift!
                    </h6>
                  </div>
                  <div>
                    <Button onClick={() => grabGiftFeedback()} primary>
                      Grab my gift
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <Feedback type="step" />
            )}
          </TextContainer>
        </Modal.Section>
      </Modal>
    </Row>
  );
};

export default Poll;
